
import { defineComponent, ref, watchEffect } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import EditableSelect from '@/components/_shared/editable-select.vue'
import { useFreeFormsModule } from '@/modules/free-forms'
import { useRoute } from 'vue-router'
import FreeFormsCreateNewTranslationDomainDialog from '@/components/free-forms/dialogs/create-new-translation-domain.vue'
import FreeFormsTranslationDomainTranslationsList from '@/components/free-forms/translation-domain-translations-list.vue'
import useTranslationHelper from '@/components/free-forms/translation-domain-helper'

export default defineComponent({
    name: 'free-forms-editable-field-description-translation',
    props: {
        modelValue: {
            type: String,
            required: true
        },
        isFormEnabled: {
            type: Boolean
        }
    },
    components: {
        EditableSelect,
        FreeFormsTranslationDomainTranslationsList
    },
    setup (props, { emit }) {
        const $q = useQuasar()
        const route = useRoute()
        const {
            updateFreeFormDescription,
            translationDomainTranslations,
            getTranslationDomainTranslations,
            getTranslationDomainByDomain
        } = useFreeFormsModule()
        const { getDescriptionTranslations, translationOptions } = useTranslationHelper()
        const { submitForm, createOnSuccess } = useFormModule()
        const localValue = ref(props.modelValue)
        const form = ref<QForm>()

        getDescriptionTranslations()
        getTranslationDomainTranslations(localValue.value)

        const lastValue = ref('')
        lastValue.value = localValue.value

        const onNewDomainCreated = (newValue: string) => {
            localValue.value = newValue
            lastValue.value = newValue
            getTranslationDomainTranslations(newValue)
        }

        const showCreateNewDomainDialog = () => {
            $q.dialog({
                component: FreeFormsCreateNewTranslationDomainDialog,
                componentProps: {
                    updateCallback: onNewDomainCreated
                }
            }).onCancel(() => {
                localValue.value = lastValue.value
            }).onOk(() => onLocalValueChange())
        }

        const updateTranslationDomain = (value: string) => {
            onLocalValueChange()
            emit('update:modelValue', value)
            getTranslationDomainTranslations(value)
            lastValue.value = value
        }

        const shouldShowWarningDialog = (value: string) => {
            const newDomain = getTranslationDomainByDomain(value)
            const lastDomain = getTranslationDomainByDomain(lastValue.value)

            return lastDomain.status === 'active' && newDomain.status === 'draft' && props.isFormEnabled
        }

        const onUpdate = (value: string) => {
            if (value === 'create_new_domain') {
                (props.isFormEnabled)
                    ? showWarningDialog(() => showCreateNewDomainDialog()) : showCreateNewDomainDialog()
            } else {
                shouldShowWarningDialog(value)
                    ? showWarningDialog(() => updateTranslationDomain(value)) : updateTranslationDomain(value)
            }
        }

        const showWarningDialog = (callback: () => void) => {
            $q.dialog({
                title: 'Warning',
                message: 'Are you sure you want to change description translation to draft? <br/>Please note that free form will be disabled.',
                html: true,
                cancel: true,
                persistent: true
            }).onOk(() => {
                callback()
            }).onCancel(() => {
                localValue.value = lastValue.value
            })
        }

        watchEffect(() => {
            localValue.value = props.modelValue
        })

        const sendRequest = async () => updateFreeFormDescription(
            route.params.formId as string,
            {
                formId: route.params.formId as string,
                descriptionTranslation: localValue.value
            })

        const onLocalValueChange = () => {
            submitForm(
                form.value,
                sendRequest,
                () => {
                    emit('update:modelValue', localValue.value)
                    createOnSuccess('Free form description translation updated')()
                }
            )
        }

        return {
            localValue,
            translationOptions,
            form,
            onUpdate,
            translationDomainTranslations,
            lastValue
        }
    }
})
